module.exports = __webpack_public_path__ + "img/wechat-icon.4c41d928.png";